// DS: MO5.1
import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import c from 'classnames';
import PlainButtonOrLink from '../PlainButtonOrLink';
import s from './AdoptableButton.scss';
const AdoptableButton = (_param)=>{
    var { className , priority , children  } = _param, props = _object_without_properties(_param, [
        "className",
        "priority",
        "children"
    ]);
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, _extends({
        className: c(className, s['root'], s[`priority-${priority}`])
    }, props), children);
};
AdoptableButton.displayName = 'AdoptableButton';
export default AdoptableButton;
